module.exports = __webpack_public_path__ + "static/media/video-banner.fc9992ba.mp4";